import { API_BASE_URL, fetchAuthenticated } from "../utils/config";
function JsonToExcel({ rawReportObject, visibleReportData, reportMeta }) {
 
  const handleExport = async () => {
    try {
      if (!window.confirm("Do you want to download this report as an Excel file?")) return;

      const {
        reportType = "Report",
        startDate = null,
        endDate = null,
        monthOverMonth = false,
        combine = false,
        vertical = false,
      } = reportMeta || {};

      // Simplified isMoM detection
      const isMoM = !!monthOverMonth;

      const bodyForExcel = {
        data: rawReportObject, 
        is_month_over_month: isMoM,
        is_combined: combine,
        is_companies_vertical: vertical,
        start_date: startDate,
        end_date: endDate,
        report_type: reportType,
      };

      const payload = {
        jsonData: {
          body: JSON.stringify(bodyForExcel), 
        },
        saveLocally: false,
      };

      // API Call
      const response = await fetchAuthenticated(`${API_BASE_URL}/quickbooks/jsonToExcel`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(await response.text());

      // Download Logic
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      
      const suffix = isMoM ? "_MoM" : combine ? "_Combined" : "";
      a.href = url;
      a.download = `${reportType || "report"}${suffix}_${startDate || "start"}_to_${endDate || "end"}.xlsx`;
      
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error("Error exporting Excel:", err);
      alert("Export failed.");
    }
  };

    return (
      <button 
        type="button" 
        onClick={handleExport} 
        className="export-btn group-btn-primary"
      >
        Export to Excel
      </button>
    );
}

export default JsonToExcel;
